import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, user, loading } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const nextUrl = params.get("next");

  // Already logged in? Skip the login screen.
  useEffect(() => {
    if (!loading && user) {
      if (nextUrl) nav(nextUrl, { replace: true });
      else nav(user.role === "admin" ? "/admin" : "/app/dashboard", { replace: true });
    }
  }, [loading, user, nav, nextUrl]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(form.email.trim(), form.password);
    setBusy(false);
    if (!r.ok) { toast.error(r.error); return; }
    toast.success(`Welcome back, ${r.user.name}`);
    if (nextUrl) nav(nextUrl);
    else nav(r.user.role === "admin" ? "/admin" : "/app/dashboard");
  };

  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="login-page">
      <PublicNav />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="font-mono-jp text-xs text-[#d7ff00] tracking-[0.3em] uppercase">LOGIN</div>
        <h1 className="mt-3 font-display text-5xl uppercase">Welcome <span className="text-[#d7ff00]">back</span></h1>
        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888]">Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-2 w-full bg-[#0e0e0e] border border-[#222] focus:border-[#d7ff00] outline-none px-4 py-3 text-white" data-testid="login-email" />
          </div>
          <div>
            <label className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888]">Password</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-2 w-full bg-[#0e0e0e] border border-[#222] focus:border-[#d7ff00] outline-none px-4 py-3 text-white" data-testid="login-password" />
          </div>
          <button type="submit" disabled={busy} className="w-full bg-[#d7ff00] text-black font-display tracking-wider uppercase text-xl py-4 hover:bg-white disabled:opacity-50" data-testid="login-submit">
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#888]">No account yet? <Link to="/register" className="text-[#d7ff00]" data-testid="goto-register">Create one</Link></p>
        <p className="mt-2 text-sm text-[#888]"><Link to="/forgot-password" className="hover:text-[#d7ff00]" data-testid="forgot-password-link">Forgot password?</Link></p>
        <p className="mt-2 text-sm text-[#888]"><Link to="/pricing" className="hover:text-white">Browse packages</Link></p>
      </div>
    </div>
  );
}
